import styled from 'styled-components';

export const DetailsBody = styled.div`
  flex: 1;
  margin-bottom: 50px;
`;

export const DetailsCards = styled.div`
  display: flex;
  justify-content: center;
  padding: 15px;

  @media screen and (max-width: 950px) {
    padding: 10px;
  }
`;

export const InformationContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  max-width: 1200px;

  @media screen and (min-width: 1400px) {
    max-width: 1400px;
  }

  @media screen and (max-width: 950px) {
    max-width: 100%;
  }
`;
